import { useEffect } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { Checklist, ChecklistUpdate } from './types';

interface EditChecklistProps {
  checklist?: Checklist;
  checklistState: ChecklistUpdate;
  setChecklistState: React.Dispatch<React.SetStateAction<ChecklistUpdate>>;
  children?: JSX.Element;
};

EditChecklist.defaultProps = {
};

function EditChecklist(props: EditChecklistProps) {
  const { checklist, checklistState, setChecklistState, children } = props;

  type ChangeEvent = (e: React.ChangeEvent<HTMLInputElement>) => void;
  const onNameChanged: ChangeEvent = e => setChecklistState({ ...checklistState, name: e.target.value });

  useEffect(() => {
    let updatedState: ChecklistUpdate = {
      name: "",
      ...checklist,
    };
    setChecklistState(updatedState);
  }, [checklist, setChecklistState]);

  return (
    <Form>
      {checklistState.id && (
        <Form.Group as={Row} controlId="checklistID" className="mb-3">
          <Form.Label column sm="2">ID</Form.Label>
          <Col sm="10">
            <p><code>{checklistState.id}</code></p>
          </Col>
        </Form.Group>
      )}
      <Form.Group as={Row} controlId="checklistName" className="mb-3">
        <Form.Label column sm="2">Name</Form.Label>
        <Col sm="10">
          <Form.Control type="text" placeholder="" value={checklistState.name || ''} onChange={onNameChanged} />
        </Col>
      </Form.Group>
      {children}
    </Form>
  );
};

export default EditChecklist;